/**
 * @generated SignedSource<<3fc233b23dab865cf6930a38a7020439>>
 * @relayHash 7e21202b926d45e062e09a0c01cc56e5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 80c8cf688c8b87204396177172e6eb577d68c8b3816e93c34f0fd8f4c331478f

import type { ConcreteRequest } from 'relay-runtime';
export type StatusAndApprovalsConfigApprovalStatusesQuery$variables = {
  cloudId: string;
};
export type StatusAndApprovalsConfigApprovalStatusesQuery$data = {
  readonly confluence_contentApprovalStatuses: ReadonlyArray<{
    readonly allowsReviews: boolean | null | undefined;
    readonly displayProperties: {
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined> | null | undefined;
};
export type StatusAndApprovalsConfigApprovalStatusesQuery = {
  response: StatusAndApprovalsConfigApprovalStatusesQuery$data;
  variables: StatusAndApprovalsConfigApprovalStatusesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "concreteType": "ConfluenceApprovalsWorkflowStatus",
    "kind": "LinkedField",
    "name": "confluence_contentApprovalStatuses",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "allowsReviews"
      },
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
        "kind": "LinkedField",
        "name": "displayProperties",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "name"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "StatusAndApprovalsConfigApprovalStatusesQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StatusAndApprovalsConfigApprovalStatusesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7e21202b926d45e062e09a0c01cc56e5",
    "id": "80c8cf688c8b87204396177172e6eb577d68c8b3816e93c34f0fd8f4c331478f",
    "metadata": {},
    "name": "StatusAndApprovalsConfigApprovalStatusesQuery",
    "operationKind": "query",
    "text": "query StatusAndApprovalsConfigApprovalStatusesQuery($cloudId:ID!){confluence_contentApprovalStatuses(cloudId:$cloudId){allowsReviews,id,displayProperties{name}}}"
  }
};
})();

(node as any).hash = "367eaae38c3e2d4ef9d0e2f94f47b108";

export default node;
